import React from 'react';

import {Box, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {IconIllustration} from 'presentation/components/IconIllustration';
import {ProfileMenuItemStatus} from './constants';
import {IconWithStatusProps} from './types';

export function IconWithStatus({iconName, status}: IconWithStatusProps) {
	const theme = useTheme();
	const isError = status === ProfileMenuItemStatus.ERROR;

	return (
		<Box position="relative">
			<IconIllustration
				customIconName={iconName}
				variant="primary"
				size="small"
				sx={{p: 1}}
			/>

			{status !== ProfileMenuItemStatus.DEFAULT && (
				<Box
					position="absolute"
					top={0}
					right={0}
					width={14}
					height={14}
					borderRadius="50%"
					display="flex"
					alignItems="center"
					justifyContent="center">
					<Icon
						name={isError ? 'error-fill' : 'check-circle-filled'}
						size={16}
						color={
							isError ? theme.colors.dark.error.main : theme.colors.light.success.main
						}
					/>
				</Box>
			)}
		</Box>
	);
}
